import { useEffect, useState } from "react";

/**
 * useOrangeCareCatalog — public GBP pricing from the canonical backend.
 *
 * Source of truth: GET /api/orangecare/catalog (projected from
 * backend/services/orangecare/plans.py). No numeric prices come from
 * AppContext.jsx anymore.
 *
 * Returns:
 *   { catalog, status: "loading" | "ready" | "error", byKey }
 *   byKey: { orangecare_landing_page, orangecare_website, orangecare_crm }
 *
 * On error the hook keeps `catalog` empty so the UI can show a safe
 * "Pricing temporarily unavailable" state instead of stale values.
 */
export default function useOrangeCareCatalog() {
  const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
  const [status, setStatus] = useState("loading");
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetch(`${BACKEND}/api/orangecare/catalog`, { cache: "no-store" })
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((data) => {
        if (!alive) return;
        setItems(data.items || []);
        setStatus("ready");
      })
      .catch(() => { if (alive) setStatus("error"); });
    return () => { alive = false; };
  }, [BACKEND]);

  const byKey = Object.fromEntries(items.map((p) => [p.plan_key, p]));
  return { catalog: items, status, byKey };
}

/** Convert minor GBP units (pence) to major (£). */
export function gbpMajor(minor) {
  const n = Number(minor);
  if (!Number.isFinite(n)) return null;
  return n / 100;
}
